import { CMSResource } from 'app/resources/cmsresource';
import { VisitingHoursFieldsResource } from "app/models/VisitingHoursFieldsResource";
import { VisitingHoursDepartmentAndKioskResource } from './VisitingHoursDepartmentAndKioskResource';


export class VisitingHoursDepartmentResource extends CMSResource {

    rid: number;
    visitingHoursFiledsResource: VisitingHoursFieldsResource[];
    departmentNameRo: string;
    departmentNameEn: string;
    departmentNameFr: string;
    departmentNameDe: string;
    userEmail: string;
    orderIndex: number;
    kioskResourceList: VisitingHoursDepartmentAndKioskResource[];
    showDelete:boolean=false;
}